import { Message } from 'element-ui'

class WebSocketClient {
  constructor(options = {}) {
    this.url = options.url || `${process.env.VUE_APP_WS_URL}`
    this.reconnectInterval = options.reconnectInterval || 3000
    this.maxReconnectAttempts = options.maxReconnectAttempts || 10
    this.heartbeatInterval = options.heartbeatInterval || 30000
    this.reconnectAttempts = 0
    this.isConnecting = false
    this.isManualClose = false
    this.isLoggedIn = false
    this.ws = null
    this.heartbeatTimer = null
    this.reconnectTimer = null
    this.eventHandlers = new Map()
    this.token = null
  }
  // 设置token并登录
  setToken(token) {
    this.token = token
    if (this.isConnected() && !this.isLoggedIn) {
      this.login(token)
    }
  }
  // 清除token
  clearToken() {
    this.token = null
    this.isLoggedIn = false
  }
  // 初始化连接（不自动登录）
  init() {
    return new Promise((resolve, reject) => {
      if (this.isConnecting) {
        this.waitForConnection(resolve, reject)
        return
      }
      if (this.isConnected()) {
        resolve()
        return
      }
      this.isManualClose = false
      this.connect(resolve, reject)
    })
  }
  waitForConnection(resolve, reject, timeout = 10000) {
    const startTime = Date.now()
    const timer = setInterval(() => {
      if (this.isConnected()) {
        clearInterval(timer)
        resolve()
      } else if (!this.isConnecting || Date.now() - startTime > timeout) {
        clearInterval(timer)
        reject(new Error('WebSocket连接超时'))
      }
    }, 100)
  }
  connect(resolve, reject) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      resolve && resolve()
      return
    }
    // 如果正在连接中，等待而不是创建新连接
    if (this.ws && this.ws.readyState === WebSocket.CONNECTING) {
      this.waitForConnection(resolve, reject)
      return
    }
    this.isConnecting = true
    try {
      this.ws = new WebSocket(this.url)
      this.ws.onopen = () => {
        console.log('WebSocket连接成功')
        this.isConnecting = false
        this.reconnectAttempts = 0
        this.startHeartbeat()
        this.emit('open')
        // 如果有token，自动登录
        if (this.token) {
          this.login(this.token)
        }
        resolve && resolve()
      }
      this.ws.onmessage = (event) => {
        this.handleMessage(event.data)
      }
      this.ws.onerror = (error) => {
        console.error('WebSocket错误:', error)
        this.emit('error', error)
        reject && reject(error)
      }
      this.ws.onclose = (event) => {
        console.log('WebSocket连接关闭:', event.code, event.reason)
        this.isLoggedIn = false
        this.stopHeartbeat()
        this.emit('close', event)
        if (!this.isManualClose) {
          setTimeout(() => {
            this.init().catch(err => {
              console.error('重连失败:', err)
            })
          }, 20000)
        }
      }
    } catch (error) {
      this.isConnecting = false
      reject(error)
    }
  }
  // 重新连接
  // reconnect() {
  //   if (this.isManualClose) return
  //   if (this.reconnectAttempts >= this.maxReconnectAttempts) {
  //     console.error('WebSocket重连次数已达上限')
  //     this.emit('reconnect_failed')
  //     return
  //   }
  //   if (this.reconnectTimer) clearTimeout(this.reconnectTimer)
  //   this.reconnectTimer = setTimeout(() => {
  //     console.log(`第${this.reconnectAttempts + 1}次重连WebSocket...`)
  //     this.reconnectAttempts++
  //     this.init().catch(err => {
  //       console.error('重连失败:', err)
  //     })
  //     // this.connect()
  //   }, this.reconnectInterval)
  // }
  // 开始心跳
  startHeartbeat() {
    this.stopHeartbeat()
    this.heartbeatTimer = setInterval(() => {
      if (this.isConnected() && this.isLoggedIn) {
        this.send({
          typeStr: 'HEARTBEAT',
          timestamp: Date.now()
        })
      }
    }, this.heartbeatInterval)
  }
  // 停止心跳
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }
  // 发送消息
  send(data) {
    if (this.isConnected()) {
      const message = typeof data === 'string' ? data : JSON.stringify(data)
      this.ws.send(message)
      return true
    }
    console.warn('WebSocket未连接，消息发送失败')
    return false
  }
  // 登录认证
  login(token) {
    if (!this.isConnected()) {
      console.warn('WebSocket未连接，无法登录')
      return false
    }
    const result = this.send({
      typeStr: 'LOGIN',
      content: JSON.stringify({ token }),
      timestamp: Date.now()
    })
    if (result) {
      this.isLoggedIn = true
    }
    return result
  }
  // 登出
  logout() {
    if (this.isConnected() && this.isLoggedIn) {
      this.send({
        typeStr: 'LOGOUT',
        timestamp: Date.now()
      })
    }
    this.isLoggedIn = false
    this.token = null
  }
  // 处理接收到的消息
  handleMessage(data) {
    try {
      const message = JSON.parse(data)
      // console.log('收到WebSocket消息:', message)
      // 重复登录
      if (message.typeStr === 'RE_LOGIN') {
        console.log('ws重复登录:', message)
        this.isManualClose = true
        this.ws.close()
        return
      }
      // 连接数超限
      if (message.typeStr === 'SESSION_LIMIT') {
        this.isManualClose = true
        this.isLoggedIn = false
        this.stopHeartbeat()
        Message.warning(message.msg || '同一账号最多允许5个页面同时在线，请关闭其他页面后重试')
        this.emit('session_limit', message)
        if (this.ws) {
          this.ws.close()
        }
        return
      }
      // 处理登录响应
      if (message.typeStr === 'LOGIN_RETURN') {
        this.isLoggedIn = true
        // this.emit('login_success', message)
        return
      }
      // 处理未授权消息
      if (message.typeStr === 'UN_AUTH') {
        this.isLoggedIn = false
        this.isManualClose = true
        this.ws.close()
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userMenus')
        this.$confirm('登录已失效，请重新登录!', '提示', {
          type: 'warning'
        }).then(async () => {
          this.$router.push('/login')
        }).catch(() => {
          this.$router.push('/login')
        });
        return
      }
      // 处理心跳响应
      if (message.typeStr === 'HEARTBEAT_RETURN') {
        // this.emit('heartbeat', message)
        return
      }
      // 处理弹窗提醒
      // if (message.typeStr === 'MSG_SEND') {
      //   this.showNotification(message)
      //   // 触发通用消息事件
      //   this.emit('message', message)
      // }
      // 触发对应的事件处理器
      if (message.typeStr === 'RELOAD_NOTICE') {
        this.emit('message', message)
        return
      }
    } catch (error) {
      console.error('解析WebSocket消息失败:', error)
    }
  }
  // 注册事件监听
  on(event, handler) {
    if (!this.eventHandlers.has(event)) {
      this.eventHandlers.set(event, [])
    }
    this.eventHandlers.get(event).push(handler)
  }
  // 触发事件
  emit(event, data) {
    const handlers = this.eventHandlers.get(event)
    if (handlers) {
      handlers.forEach(handler => {
        try {
          handler(data)
        } catch (error) {
          console.error(`事件处理器执行错误: ${event}`, error)
        }
      })
    }
  }
  // 移除事件监听
  off(event, handler) {
    if (handler) {
      const handlers = this.eventHandlers.get(event)
      if (handlers) {
        const index = handlers.indexOf(handler)
        if (index > -1) {
          handlers.splice(index, 1)
        }
      }
    } else {
      this.eventHandlers.delete(event)
    }
  }
  // 检查连接状态
  isConnected() {
    return this.ws && this.ws.readyState === WebSocket.OPEN
  }
  // 检查是否已登录
  isLogin() {
    return this.isLoggedIn && this.isConnected()
  }
  // 手动关闭连接
  close() {
    this.isManualClose = true
    this.isLoggedIn = false
    this.token = null
    this.stopHeartbeat()
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer)
    }
    if (this.ws) {
      console.log('关闭ws')
      this.ws.close()
    }
  }
  // 获取连接状态
  getReadyState() {
    return this.ws ? this.ws.readyState : WebSocket.CLOSED
  }
}
// 创建单例实例
let wsInstance = null
export function getWebSocket() {
  if (!wsInstance) {
    wsInstance = new WebSocketClient()
  }
  return wsInstance
}
export default WebSocketClient